import ReactSelect from "./Select";

export default ReactSelect;
